<document-lines-editor
  #lineGrid
  [title]="'Doc::CustomerQuote:ProductsAndServices' | abpLocalization"
  [columnDefs]="columnDefs"
  [rows]="lines"
  [getContextMenuItems]="getContextMenuItems"
  [treeData]="false"
  [textLineRole]="textLineRole"
  [chapterLineRole]="chapterLineRole"
  [actionBtns]="actionBtns"
  gridStateKey="preparationLinesCreationGrid"
  [onCellValueChanged]="onCellValueChanged"
  [pinnedBottomRowData]="pinnedBottomRowData"
  [rowClassRules]="rowClassRules"
  [isDialogBox]="true"
  [fillRemainingHeight]="false"
  [domLayout]="'autoHeight'"
></document-lines-editor>
